import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/index.ts";
import { useDispatch } from "react-redux";
import {
  setLockBalanceClose,
  setLockFortuneClose,
  setLockLoginClose,
  setModalBalance,
  setModalFortune,
  setModalLogin,
  setPromoCode,
  setTypeLogin
} from "../../store/siteSlice";
import { ENUM_LCS_NAME, ENUM_LOGIN } from "../../store/enums";
import { useReadLocalStorage } from "usehooks-ts";
import { parseHashString } from "../../utils/utils.js";
import { setCurrency } from "../../store/userSlice.js";
import useNavigateWithSearch from "../useNavigateWitchSearch.js";

/**
 * @description не работает для авторизованного и если в ТГ боте
    если человек уже входил, то #signup_on будет работать как signup
 */

export const ENUM_HASH = {
  signup: "#signup",
  signup_on: "#signup_on",
  signup_deposit_on: "#signup_deposit_on",
  fortune: "#fortune",
  fortune_on: "#fortune_on",
  deposit: "#deposit",
  promocode: "#promocode"
};

export default function useUrlParc() {
  const dispatch = useDispatch();
  const userId = useAppSelector((state) => state.user.userId);
  const isTgBot = useAppSelector((state) => state.common.isTgBot);
  const firstDeposit = useAppSelector((state) => state.promotions.firstDeposit?.values);
  const mainLoader = useAppSelector((state) => state.site.mainLoader);
  const alreadyAccount = useReadLocalStorage(ENUM_LCS_NAME.alreadyAccount);
  const typeLogin = alreadyAccount ? ENUM_LOGIN.login : ENUM_LOGIN.register;

  const location = useLocation();
  const navigate = useNavigateWithSearch();
  const hash = location.hash;

  const parseDeposit = (hash) => {
    try {
      const hashes = parseHashString(hash);

      if (hashes.deposit) {
        if (!userId) {
          dispatch(setTypeLogin(typeLogin));
          dispatch(setModalLogin(true));
          return;
        }

        const params = hashes.deposit;

        if (params) {
          const currency = params["currency"];
          const amount = params["amount"] || true;

          if (currency) dispatch(setCurrency(currency));
          dispatch(setModalBalance(amount));
          navigate(location.pathname);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  const parsePromocode = (hash) => {
    try {
      const hashes = parseHashString(hash);

      if (hashes.promocode) {
        dispatch(setPromoCode(true));
        navigate(location.pathname);
      }
    } catch (e) {
      console.log(e);
    }
  };

  //для всех на сайте
  useEffect(() => {
    if (isTgBot) return;
    if (mainLoader) return;

    setTimeout(() => {
      parseDeposit(hash);
      parsePromocode(hash);
    }, 300);
  }, [isTgBot, mainLoader, hash]);

  // логика открытия логина и депозита
  useEffect(() => {
    if (isTgBot) return;
    const hash = location.hash;
    const type = alreadyAccount ? ENUM_LOGIN.login : ENUM_LOGIN.register;
    if (userId) return;

    //для неавторизованных

    // проверка только на одно, потому что #signup_up включает в себя #signup
    if (alreadyAccount) {
      if (hash.includes(ENUM_HASH.signup)) {
        dispatch(setTypeLogin(type));
        dispatch(setModalLogin(true));
        dispatch(setLockLoginClose(false));
      }
      return;
    }

    // если вообще нет включения #signup то выход
    if (!hash.includes(ENUM_HASH.signup)) return;

    const isLock = hash.includes(ENUM_HASH.signup_on) || hash.includes(ENUM_HASH.signup_deposit_on);
    dispatch(setLockLoginClose(isLock));
    dispatch(setLockBalanceClose(hash.includes(ENUM_HASH.signup_deposit_on)));

    if (hash.includes(ENUM_HASH.signup_deposit_on)) dispatch(setModalBalance(true));

    dispatch(setTypeLogin(type));
    dispatch(setModalLogin(true));
  }, [userId, isTgBot, location, alreadyAccount]);

  // логика открытия колеса фортуны
  useEffect(() => {
    const hash = location.hash;

    // if (!firstDeposit) return;
    if (userId) return;
    if (!hash.includes(ENUM_HASH.fortune)) return;
    const lock = hash.includes(ENUM_HASH.fortune_on) && !alreadyAccount;
    dispatch(setLockFortuneClose(lock));
    dispatch(setModalFortune(true));
  }, [firstDeposit, userId]);
}
